"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionFormModalCtrl = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const services_1 = require("../../services");
const log_service_1 = require("../../services/log.service");
const page_state_1 = require("../../state/page.state");
const store_1 = require("../../store");
class CollectionFormModalCtrl {
    constructor(collections) {
        this.collectionStats = [];
        this.failures = [];
        this.updatingForm = false;
        this.collections = collections;
    }
    updateFormCollections() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.setUpdatingForm(true);
            const outputs = [];
            for (const stat of this.collectionStats) {
                if (!stat.latestFormRevision) {
                    return;
                }
                if (stat.actualFormRevision === stat.latestFormRevision) {
                    continue;
                }
                const formModel = yield store_1.AppStore.Form.fetch(stat.latestFormRevision);
                const collectionModel = yield store_1.AppStore.Collection.fetch(stat.collectionRevision);
                const upgrade = core_shared_1.IkeModel.Collection.upgrade([collectionModel], formModel);
                const output = yield upgrade.process(log_service_1.Logger);
                if (output.result !== 'success') {
                    output.fields.forEach(field => {
                        this.failures.push({
                            failure: field,
                            collectionId: stat.collectionId,
                            collectionTitle: stat.collectionTitle
                        });
                    });
                }
                else {
                    outputs.push(output.collections[0]);
                }
            }
            if (this.failures.length > 0) {
                throw new Error((0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_ERROR));
            }
            const newCollectionUuids = [];
            for (const newCollection of outputs) {
                const savedCollection = yield this.saveCollection(newCollection);
                newCollectionUuids.push(savedCollection.uuid);
            }
            yield page_state_1.CurrentState.updateInspectedCollection();
            yield this.refresh(newCollectionUuids);
            this.setUpdatingForm(false);
        });
    }
    saveCollection(newCollection) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const newCollectionJsonSave = yield core_shared_1.IkeModel.Collection.write(newCollection);
            const rest = services_1.Services.Department.rest;
            const savedCollection = yield rest.save(rest.Objects.Collection, newCollectionJsonSave);
            return savedCollection;
        });
    }
    refresh(collectionUuids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const collectionSummaries = yield Promise.all(collectionUuids.map(uuid => store_1.AppStore.CollectionSummary.getFetchableByUuid(uuid).refetch()));
            return Promise.all([
                store_1.AppStore.Tag.refresh(),
                ...this.getTagIds(collectionSummaries).map(tagId => store_1.AppStore.TagSummary.getFetchable(tagId).refetch())
            ]);
        });
    }
    getTagIds(collectionSummaries) {
        const tags = {};
        for (const collectionSummary of collectionSummaries) {
            for (const tag of collectionSummary.tags) {
                if (!tags[tag] && !(0, core_api_1.isSystemTag)(tag)) {
                    tags[tag] = true;
                }
            }
        }
        return Object.keys(tags);
    }
    setUpdatingForm(updatingForm) {
        this.updatingForm = updatingForm;
    }
    getCollectionStats(departmentForms) {
        const collectionStats = [];
        this.collections.forEach(collectionSummary => {
            const formSummary = store_1.AppStore.FormSummary.get(collectionSummary.formRevision);
            const stat = {
                collectionId: collectionSummary.collectionId,
                collectionTitle: collectionSummary.title,
                collectionRevision: collectionSummary.revision,
                formUuid: formSummary ? formSummary.uuid : '',
                actualFormRevision: collectionSummary.formRevision,
                actualFormDate: formSummary ? formSummary.updatedAt : ''
            };
            collectionStats.push(stat);
        });
        collectionStats.forEach(stat => {
            const form = stat.formUuid ? departmentForms.find(({ uuid }) => uuid === stat.formUuid) : null;
            if (form) {
                stat.latestFormRevision = form.revision;
                stat.latestFormName = form.displayname;
                stat.latestFormDate = form.updatedAt;
            }
        });
        this.collectionStats = collectionStats;
        return collectionStats;
    }
}
exports.CollectionFormModalCtrl = CollectionFormModalCtrl;
tslib_1.__decorate([
    mobx_1.observable
], CollectionFormModalCtrl.prototype, "tagName", void 0);
tslib_1.__decorate([
    mobx_1.observable
], CollectionFormModalCtrl.prototype, "updatingForm", void 0);
tslib_1.__decorate([
    mobx_1.action
], CollectionFormModalCtrl.prototype, "setUpdatingForm", null);
//# sourceMappingURL=collection.form.modal.ctrl.js.map